import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { FC, useEffect } from 'react';
import {
	VAT_CORRECTIONS_SCHEMES,
	VAT_CORRECTIONS_SCHEMES_TO_SCHEMES,
	VAT_CORRECTIONS_SCHEME_NAMES,
	VatCorrectionsScheme,
} from 'redux/reducers/vatCorrections/constants';
import { useSelector } from 'react-redux';
import { getConfirmedOrders } from 'redux/reducers/orders/selectors';
import { TStep1Props } from './types';
import { Notice } from '../Notice';

export const Step1: FC<TStep1Props> = ({
	typeOfReport,
	handleTypeOfReportChange,
	hasSelectedOrder,
}) => {
	const confirmedOrder = useSelector(getConfirmedOrders);
	const schemes = confirmedOrder?.data[0]?.schemes;

	return (
		<>
			<FormControl>
				<RadioGroup
					aria-labelledby="demo-radio-buttons-group-label"
					defaultValue="IOSS"
					name="radio-buttons-group"
					value={typeOfReport}
					onChange={(e) => handleTypeOfReportChange(e.target.value as VatCorrectionsScheme)}
				>
					{VAT_CORRECTIONS_SCHEMES.map((scheme) => (
						<FormControlLabel
							key={scheme}
							value={scheme}
							control={<Radio />}
							label={VAT_CORRECTIONS_SCHEME_NAMES[scheme]}
							disabled={
								hasSelectedOrder &&
								!schemes?.includes(
									VAT_CORRECTIONS_SCHEMES_TO_SCHEMES?.[
										scheme as keyof typeof VAT_CORRECTIONS_SCHEMES_TO_SCHEMES
									] as unknown as VatCorrectionsScheme,
								)
							}
						/>
					))}
				</RadioGroup>
			</FormControl>
			{!!typeOfReport && <Notice typeOfReport={typeOfReport} />}
		</>
	);
};
